<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parking.title"></app-title-bar>
@if (hasLinkedParker) {
  <div class="row">
    <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">

      <form id="parkingForm" [formGroup]="parkingForm" autocomplete="off">
        <div>
          <div class="col-12 col-lg-12">
            <div class="d-flex flex-row justify-content-end">
              @if (numActiveParkingSessions > 1) {
                <div>
                  <button type="button"
                          class="btn btn-secondary switchButton"
                          title="previous parking process"
                          (click)="onPreviousParkingProcess()">
                    <div class="e-icons icon-arrow--left"></div>
                  </button>
                </div>
              }
              @if (numActiveParkingSessions > 1) {
                <div class="ms-2">{{this.selectedParkingProcessInfoIndex + 1}} / {{this.numActiveParkingSessions}}</div>
              }
              @if (numActiveParkingSessions > 1) {
                <div class="ms-2">
                  <button type="button"
                          class="btn btn-secondary switchButton"
                          title="next parking process"
                          (click)="onNextParkingProcess()">
                    <div class="e-icons icon-arrow--right"></div>
                  </button>
                </div>
              }
              <div class="ms-2">
                <button type="button"
                        class="btn btn-secondary switchButton"
                        title="new parking process"
                        (click)="onNewParkingProcess()">
                  <div class="e-icons icon-add"></div>
                </button>
              </div>
            </div>
          </div>
          @if (showClientDropDown) {
            <div class="mb-2 align-items-center">
              <label>{{ 'i18n.domain.parking.client' | translate }}</label>
              <ejs-dropdownlist formControlName="clientId"
                                id="clientId"
                                [fields]="clientDropdownSettings"
                                [dataSource]="clientDropdownValues"
                                (change)="resetZone($event)"
                                (valueChange)="onClientValueChange($event)"></ejs-dropdownlist>
              <app-error-messages [control]="parkingForm.get('clientId')"></app-error-messages>
              @if (errors.clientNotFound) {
                <small class="text-danger">
                  {{'i18n.domain.parking.errors.clientNotFound' | translate:{clientId: errors.clientNotFound} }}
                </small>
              }
            </div>
          }
          @if (clientSelected) {
            <div class="align-items-center">
              <label>{{ 'i18n.domain.parking.zone' | translate }}</label>
              <ejs-dropdownlist formControlName="zoneId"
                                id="zoneId"
                                [fields]="clientDropdownSettings"
                                [dataSource]="zoneDropdownValues"
                                (change)="resetSubscription($event)"
                                (valueChange)="onZoneValueChange($event)">
                <ng-template #valueTemplate
                            let-data>
                  @if (data?.name.length) {
                    <div class="line-height">
                      @for (zone of data.name; track zone; let last = $last) {
                        <span
                            [ngClass]="{'fw-bold': last}"
                            class="slash-separated">{{zone}}</span>
                      }
                    </div>
                  }
                </ng-template>
                <ng-template #itemTemplate let-data>
                  @if (data?.name.length) {
                    @for (zone of data.name; track zone; let last = $last) {
                      <span
                        [ngClass]="{'fw-bold': last}"
                        class="slash-separated">{{zone}}</span>
                    }
                  }
                </ng-template>
              </ejs-dropdownlist>
              <app-error-messages [control]="parkingForm.get('zoneId')"></app-error-messages>
              @if (errors.zoneNotFound) {
                <small class="text-danger">
                  {{'i18n.domain.parking.errors.zoneNotFound' | translate:{zone:errors.zoneNotFound} }}
                </small>
              }
            </div>
          }

          @if (zoneSelected) {
            <div class="mt-2 align-items-center">
              <label>{{ 'i18n.domain.parking.subscription' | translate }}</label>
              <ejs-dropdownlist formControlName="subscriptionAssignmentId"
                                id="subscriptionAssignmentId"
                                [fields]="clientDropdownSettings"
                                [dataSource]="subscriptionsDropdownValues"
                                (valueChange)="onSubscriptionValueChange($event)"></ejs-dropdownlist>
              <app-error-messages [control]="parkingForm.controls.subscriptionAssignmentId"></app-error-messages>
              @if (errors.subscriptionNotFound) {
                <small class="text-danger">
                  {{'i18n.domain.parking.errors.subscriptionNotFound' | translate:{subscription: errors.subscriptionNotFound} }}
                </small>
              }
              @if (errors.noZoneSelected) {
                <small class="text-danger">
                  {{'i18n.domain.parking.errors.noZoneSelected' | translate}}
                </small>
              }
              @if (parkingQuotaInfoTextParams) {
                <small class="subscription-info">
                  <span class="e-icons icon-information me-1"></span>{{'i18n.domain.parking.parkingQuotaInfo' | translate: parkingQuotaInfoTextParams}}
                </small>
              }
            </div>
          }
          @if (zoneSelected && parkingSpaceNumberDefinition != null) {
            <div class="mt-2 align-items-center">
              <label for="parkingSpaceNumber">{{ 'i18n.domain.parking.parkingSpaceNumber' | translate }}</label>
              <input type="text"
                    class="form-control"
                    formControlName="parkingSpaceNumber"
                    id="parkingSpaceNumber"
                    name="parkingSpaceNumber"
                    autocomplete="off" />
              <app-error-messages [control]="parkingForm.controls.parkingSpaceNumber"></app-error-messages>
            </div>
          }
        </div>

        @if (parkingForm.controls.subscriptionAssignmentId.value > 0 || isCheckedIn) {
          <div>
            <div class="mt-4 align-items-center">
              <div class="col">
                <h3>{{ 'i18n.domain.parking.vehicle' | translate }}</h3>
              </div>
            </div>
            <div class="mt-2 align-items-center">
              <label>{{ 'i18n.domain.parking.storedVehicle' | translate }}</label>
              <ejs-dropdownlist formControlName="controlPlateId"
                                id="controlPlateId"
                                [fields]="clientDropdownSettings"
                                [dataSource]="controlPlateDropdownValues"
                                (valueChange)="onControlPlateValueChange($event)"></ejs-dropdownlist>
              <app-error-messages [control]="parkingForm.controls.controlPlateId"></app-error-messages>
              @if (errors.controlPlateNotFound) {
                <small class="text-danger">
                  {{'i18n.domain.parking.errors.controlPlateNotFound' | translate:{controlPlate: errors.controlPlateNotFound.toUpperCase()} }}
                </small>
              }
            </div>
            @if (isAddVehicle) {
              <div [formGroup]="vehicleGroup">
                <div class="row mt-4 align-items-center">
                  <div class="col">
                    <h4>{{ 'i18n.domain.parking.addVehicle' | translate }}</h4>
                  </div>
                </div>
                <div class="mt-2">
                  <label>{{ 'i18n.domain.parking.type' | translate }}</label>
                  <app-enum-drop-down-list formControlName="type"
                                          id="type"
                                          width="100%"
                                          [enumType]="ControlPlateType"
                                          [showClearButton]="false"
                                          baseTranslationString="i18n.shared.controlPlateType."></app-enum-drop-down-list>
                  <app-error-messages [control]="parkingForm.controls.newVehicle.controls.type"></app-error-messages>
                </div>
                <div class="mt-2 align-items-center">
                  <label>{{ 'i18n.domain.parking.country' | translate }}</label>
                  <ejs-dropdownlist [dataSource]="countryList"
                                    [fields]="enumDropdownSettings"
                                    [allowFiltering]="true"
                                    id="countryCode"
                                    formControlName="countryCode"></ejs-dropdownlist>
                </div>
                <div class="mt-2 align-items-center">
                  <label for="numberPlate">{{ 'i18n.domain.parking.numberPlate' | translate }}</label>
                  <input id="numberPlate"
                        type="text"
                        class="form-control"
                        name="numberPlate"
                        formControlName="numberPlate"
                        autocomplete="off"/>
                  <app-error-messages [control]="parkingForm.controls.newVehicle.controls.numberPlate"></app-error-messages>
                </div>
              </div>
            }
          </div>
        }
        <!-- @if(parkingForm.controls.subscriptionAssignmentId.value > 0 && !isCheckedIn) {}
        <div>
          <div class="row mt-2">
            <div class="col-4">
              <label class="inline-label">{{ 'i18n.domain.parking.max-parking-duration' | translate }}</label>
            </div>
            <div class="col-8 inline-label">
              {{maxParkingDurationStr | translate}}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-4">
              <label class="inline-label">{{ 'i18n.domain.parking.parking-duration' | translate }}</label>
            </div>
            <div class="col-8">
              <app-multi-field-duration-picker [form]="parkingForm.get('parkingDuration').get('durationForm')"></app-multi-field-duration-picker>
            @if(parkingForm.get('parkingDuration').get('durationForm').invalid && parkingForm.get('parkingDuration').get('durationForm').touched) {
              <div class="error-message-wrapper">
                <span class="error-message-own-line">
                  {{'i18n.domain.parking.errors.duration-error' | translate}}
                </span>
              </div>
            }
            @if(parkingForm.get('parkingDuration').hasError('maxDurationExceeded') && parkingForm.get('parkingDuration').get('durationForm').touched) {
              <div class="error-message-wrapper">
                <span class="error-message-own-line">
                  {{'i18n.domain.parking.errors.max-parking-duration-exceeded' | translate}}
                </span>
              </div>
            }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-4">
              <label class="inline-label">{{ 'i18n.domain.parking.end-time' | translate }}</label>
            </div>
            <div class="col-8 inline-label">
              {{parkingEndTimeText}}
            </div>
          </div>
        </div>
      }-->
      </form>

      @if (isCheckedIn) {
        <div>
          <div class="row mt-4">
            <div class="col">
              <h3>{{ 'i18n.domain.parking.activeSession' | translate }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>
                <span class="fw-bold">{{ 'i18n.domain.parking.startTime' | translate }}</span>
              </div>
              <div>
                {{getStartTime()}}
              </div>
            </div>
            <div class="col-6">
              <div>
                <span class="fw-bold">{{ 'i18n.domain.parking.duration' | translate }}</span>
              </div>
              <div>
                <span [ngClass]="{'text-danger': isOverMaxParkingDuration, 'text-warning': isCloseToMaxParkingDuration}">{{getTimeElapsed()}}h</span>
              </div>
            </div>
          </div>
          @if (hasTariffs) {
            <div class="row">
              <div class="col-6">
                <div>
                  <span class="fw-bold">{{ 'i18n.domain.parking.maxEndTime' | translate }}</span>
                </div>
                <div>
                  {{getMaxEndTime() | translate}}
                </div>
              </div>
              @if (maxEndTime) {
                <div class="col-6">
                  <div>
                    <span class="fw-bold">{{ 'i18n.domain.parking.maxParkingDuration' | translate }}</span>
                  </div>
                  <div>
                    {{getMaxParkingDuration()}}h
                  </div>
                </div>
              }
            </div>
          }
          @if (isParkingTimeExpired) {
            <div class="row">
              <div class="col-12">
                <div class="alert alert-danger parking-time-expired-alert">
                  {{'i18n.domain.parking.errors.parkingExpired' | translate}}
                </div>
              </div>
            </div>
          }
        </div>
      }

      <div class="row mt-4">
        <div class="col">
          @if (!isCheckedIn && isParkingPossible) {
            <div class="my-2">
              {{ 'i18n.domain.parking.parkUntil' | translate }}: <span class="fw-bold">{{getMaxParkingEndTimeWithDuration() | translate}}</span>
            </div>
          }

          @if (!isParkingPossible && !isCheckedIn && subscriptionSelected) {
            <div class="alert alert-danger">
              {{'i18n.domain.parking.errors.noParkingPossible' | translate}}
            </div>
          }

          @if (!hasFoundZones && isAdd) {
            <div class="alert alert-danger">
              {{(numActiveParkingSessions ? 'i18n.domain.parking.errors.parkingQuotaReached' : 'i18n.domain.parking.errors.noZonesFound') | translate}}
            </div>
          }

          @if (!hasFoundSubscriptions && isAdd) {
            <div class="alert alert-danger">
              {{(numActiveParkingSessions ? 'i18n.domain.parking.errors.parkingQuotaReached' : 'i18n.domain.parking.errors.noSubscriptionsAssigned') | translate}}
            </div>
          }

          @if (!hasFoundControlPlates && isAdd) {
            <div class="alert alert-danger">
              {{(numActiveParkingSessions ? 'i18n.domain.parking.errors.parkingQuotaReached' : 'i18n.domain.parking.errors.noControlPlatesFound') | translate}}
            </div>
          }

          @if (isCheckedIn || isParkingPossible) {
            <button class="btn w-100"

                    [ngClass]="{'btn-danger': isCheckedIn, 'btn-primary': !isCheckedIn}"
                    [disabled]="isCheckedIn ? false : !parkingForm.valid"
                    (click)="isCheckedIn ? checkout() : checkin()">
              {{ isCheckedIn ? ('i18n.domain.parking.checkout' | translate) : ('i18n.domain.parking.checkin' | translate) }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>

} @else {
  <div class="alert alert-danger" role="alert">
    {{'i18n.domain.parking.errors.noLinkedParker' | translate}}
  </div>
}

